module.exports = __webpack_public_path__ + "static/media/expert (4).b27901f9.png";